import { z } from "zod";

/** Shared `?tagId=` search for command-palette tag actions. */
export const tagIdSearchSchema = z.object({
	tagId: z.string().min(1).optional().catch(undefined),
});

export type TagIdSearch = z.infer<typeof tagIdSearchSchema>;
